module.exports = __webpack_public_path__ + "static/media/adjustable.a507abef.png";